import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutPageComponent } from './componenets/layout-page/layout-page.component';
import { HomePageComponent } from './componenets/home-page/home-page.component';
import { StartupPageComponent } from './componenets/startup-page/startup-page.component';
import { IncubatorsListComponent } from './componenets/startup-page/incubators-list/incubators-list.component';
import { IncubatorsDetailsComponent } from './componenets/startup-page/incubators-details/incubators-details.component';
import { EventsPageComponent } from './componenets/events-page/events-page.component';
import { GalleryPageComponent } from './componenets/gallery-page/gallery-page.component';
import { BlogPageComponent } from './componenets/blog-page/blog-page.component';
import { ContactPageComponent } from './componenets/contact-page/contact-page.component';
import { LoginPageComponent } from './componenets/auth/login-page/login-page.component';
import { RegisterPageComponent } from './componenets/auth/register-page/register-page.component';
import { EventDetailsComponent } from './componenets/events-page/event-details/event-details.component';
import { EventListComponent } from './componenets/events-page/event-list/event-list.component';
import { BlogListComponent } from './componenets/blog-page/blog-list/blog-list.component';
import { BlogDetailsComponent } from './componenets/blog-page/blog-details/blog-details.component';
import { ProfilePageComponent } from './componenets/pages/profile-page/profile-page.component';
import { IncubatorListComponent } from './componenets/pages/incubator-list/incubator-list.component';
import { PolicyPageComponent } from './componenets/layout-page/policy-page/policy-page.component';
import { TermsPageComponent } from './componenets/layout-page/terms-page/terms-page.component';
import { SearchPageComponent } from './componenets/pages/search-page/search-page.component';
// import { InitiativesComponent } from './componenets/startup-page/initiatives/initiatives.component';
import { IncuNewslettersComponent } from './componenets/startup-page/incubators-details/incu-newsletters/incu-newsletters.component';
import { ResourcesPageComponent } from './componenets/resources-page/resources-page.component';
import { InitiativesPageComponent } from './componenets/initiatives-page/initiatives-page.component';
import { PartnerregisterPageComponent } from './componenets/auth/partnerregister-page/partnerregister-page.component';
import { CorporatePageComponent } from './componenets/corporate-page/corporate-page.component';
import { CsrsdocListComponent } from './componenets/csrsdoc-page/csrsdoc-list/csrsdoc-list.component';
import { CsrsprojectdetailPageComponent } from './componenets/csrsprojectdetail-page/csrsprojectdetail-page.component';
import { CsrprojectDetailspageComponent } from './componenets/csrsprojectdetail-page/csrproject-detailspage/csrproject-detailspage.component';
import { CsrsListComponent } from './componenets/csrsprojectdetail-page/csrs-list/csrs-list.component';
import { CorporateProfileComponent } from './componenets/corporate-profile/corporate-profile.component';
import { CsrsdocaddPageComponent } from './componenets/csrsdocadd-page/csrsdocadd-page.component';
import { CsrsportNewPageComponent } from './componenets/csrsport-new-page/csrsport-new-page.component';
import { ChangePasswordComponent } from './componenets/auth/change-password/change-password.component';
import { NewsletterPageComponent } from './componenets/newsletter-page/newsletter-page.component';
// import { AccelatorsPageComponent } from './componenets/newcorporate-page/accelators-page/accelators-page.component';
import { NewcorporatePageComponent } from './componenets/newcorporate-page/newcorporate-page.component';
import { AccelatorsListComponent } from './componenets/newcorporate-page/accelators-list/accelators-list.component';
import { AccelatorsDetailsComponent } from './componenets/newcorporate-page/accelators-details/accelators-details.component';
import { ToiletPageComponent } from './componenets/toilet-page/toilet-page.component';
import { ToiletnewPageComponent } from './componenets/toiletnew-page/toiletnew-page.component';
import { NewpreIncubatorComponent } from './componenets/auth/newpre-incubator/newpre-incubator.component';
import { PreIncubationModule } from '../admin/pre-incubation/pre-incubation.module';
import { PreIncubatorListComponent } from './componenets/pages/pre-incubator-list/pre-incubator-list.component';
import { ConnectWithIncubatorListComponent } from './componenets/pages/ConnectwithIncubator-list/connect-with-incubator-list/connect-with-incubator-list.component';
import { PreIncubationHomeComponent } from './componenets/pre-incubation-home/pre-incubation-home.component';
import { CoeHomePageComponent } from './componenets/Coe-home-page/coe-home-page.component';
import { CoeLoginPageComponent } from './componenets/auth/coe-login-page/coe-login-page.component';
import { CoeListComponent } from './componenets/pages/coe-list/coe-list.component';
// import { AccelatorsPageComponent } from './componenets/newcorporate-page/accelators-page/accelators-page.component';
// import { AccelatorsPageComponent } from './componenets/newcorporate-page/accelators-page/accelators-page.componentent';

const routes: Routes = [
  {
    path: '',
    component: LayoutPageComponent,
    data: { title: '' },
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      {
        path: 'home',
        component: HomePageComponent,
        data: { title: 'Home', animation: 's1' },
      },
      {
        path: 'toilet',
        component: ToiletPageComponent,
        data: { title: 'Toilet', animation: 's1' },
      },
      {
        path: 'ntoilet',
        component: ToiletnewPageComponent,
        data: { title: 'Toilet', animation: 's1' },
      },

      {
        path: 'ncoporate',
        component: NewcorporatePageComponent,
        data: { title: 'Newcorporate', animation: 's3' },
        children: [
          {
            path: '',
            component: AccelatorsListComponent,
            data: { title: 'List', animation: 's2' },
          },
          {
            path: 'details',
            component: AccelatorsDetailsComponent,
            data: { title: 'Details', animation: 's3' },
          },
        ],
      },
      {
        path: 'incubators',
        component: StartupPageComponent,
        data: { title: 'Incubators' },
        children: [
          {
            path: '',
            component: IncubatorsListComponent,
            data: { title: 'List', animation: 's2' },
          },
          {
            path: 'details',
            component: IncubatorsDetailsComponent,
            data: { title: 'Details', animation: 's3' },
          },
        ],
      },
      {
        path: 'event',
        component: EventsPageComponent,
        data: { title: 'Events', animation: 's3' },
        children: [
          {
            path: '',
            component: EventListComponent,
            data: { title: 'List', animation: 's2' },
          },
          {
            path: 'details',
            component: EventDetailsComponent,
            data: { title: 'Details', animation: 's3' },
          },
        ],
      },
      {
        path: 'gallery',
        component: GalleryPageComponent,
        data: { title: 'Gallery', animation: 's4' },
      },
      {
        path: 'resources',
        component: ResourcesPageComponent,
        data: { title: 'Resources', animation: 's3' },
      },
      // {
      //   path: 'CSRS', component: CSRSportComponent, data: { title: 'CSRS', animation: 's3' }
      // },
      {
        path: 'CSRS',
        component: CsrsportNewPageComponent,
        data: { title: 'CSRS', animation: 's3' },
      },
      {
        path: 'pre-incubator-register',
        component: NewpreIncubatorComponent,
        data: { title: 'Pre-Incubator', animation: 's3' },
      },
      {
        path: 'coe-register',
        component: CoeLoginPageComponent,
        data: { title: 'Coe', animation: 's3' },
      },
      {
        path: 'pre-incubators',
        component: PreIncubationHomeComponent,
        data: { title: 'Pre-Incubator-Home', animation: 's3' },
      },
      {
        path: 'coe',
        component: CoeHomePageComponent,
        data: { title: 'Pre-Incubator-Home', animation: 's3' },
      },
      {
        path: 'change-pass',
        component: ChangePasswordComponent,
        data: { title: 'Change password', animation: 's3' },
      },
      {
        path: 'csrsavailproject',
        component: CsrsprojectdetailPageComponent,
        data: { title: 'CSR-ProjectDetail', animation: 's2' },
        children: [
          {
            path: '',
            component: CsrsListComponent,
            data: { title: 'CSR-ProjectDetailli', animation: 's2' },
          },
          {
            path: 'project-details',
            component: CsrprojectDetailspageComponent,
            data: { title: 'Details', animation: 's3' },
          },
        ],
      },
      // {
      //   path: 'csrsavailproject-detail', component: CsrprojectDetailspageComponent, data: { title: 'CSRS', animation: 's3' }
      // },
      {
        path: 'uploadcsrsdoc',
        component: CsrsdocListComponent,
        data: { title: 'Upload-Csrs-Document', animation: 's3' },
        children: [
          {
            path: '',
            component: CsrsdocListComponent,
            data: { title: 'List', animation: 's2' },
          },
          {
            path: 'add',
            component: CsrsdocaddPageComponent,
            data: { title: 'Add', animation: 's3' },
          },
        ],
      },
      {
        path: 'csrdocadd',
        component: CsrsdocaddPageComponent,
        data: { title: 'CSR-Add-Document', animation: 's3' },
      },
      {
        path: 'initiatives',
        component: InitiativesPageComponent,
        data: { title: 'Initiatives', animation: 's5' },
      },
      {
        path: 'inc-newsletters',
        component: IncuNewslettersComponent,
        data: { title: 'inc-newsletters', animation: 's5' },
      },
      {
        path: 'newsletters-details',
        component: NewsletterPageComponent,
        data: { title: 'newsletters-details', animation: 's5' },
      },
      {
        path: 'blog',
        component: BlogPageComponent,
        data: { title: 'Blog', animation: 's1' },
        children: [
          {
            path: '',
            component: BlogListComponent,
            data: { title: 'List', animation: 's2' },
          },
          {
            path: 'details',
            component: BlogDetailsComponent,
            data: { title: 'Details', animation: 's3' },
          },
        ],
      },
      {
        path: 'contact-us',
        component: ContactPageComponent,
        data: { title: 'Contact Us', animation: 's2' },
      },
      {
        path: 'login',
        component: LoginPageComponent,
        data: { title: 'Login', animation: 's3' },
      },

      {
        path: 'register',
        component: RegisterPageComponent,
        data: { title: 'Register', animation: 's4' },
      },
      {
        path: 'partner-register',
        component: PartnerregisterPageComponent,
        data: { title: 'Partner-Register', animation: 's4' },
      },
      {
        path: 'partner-profile',
        component: CorporatePageComponent,
        data: { title: 'Partner-Profile', animation: 's4' },
      },
      {
        path: 'profile',
        component: ProfilePageComponent,
        data: { title: 'Profile' },
      },
      {
        path: 'corporate-profile',
        component: CorporateProfileComponent,
        data: { title: 'Corporate-Profile' },
      },
      {
        path: 'incubator-list',
        component: IncubatorListComponent,
        data: { title: 'Incubator List' },
      },
      {
        path: 'pre-incubator-list',
        component: PreIncubatorListComponent,
        data: { title: 'Pre-Incubator List' },
      },
      {
        path: 'coe-list',
        component: CoeListComponent,
        data: { title: 'CoE List' },
      },
      {
        path: 'connectWithIncubator-list',
        component: ConnectWithIncubatorListComponent,
        data: { title: 'connectWithIncubator List' },
      },
      {
        path: 'terms-conditions',
        component: TermsPageComponent,
        data: { title: 'Terms & Conditions', animation: 's1' },
      },
      {
        path: 'privacy-policy',
        component: PolicyPageComponent,
        data: { title: 'Privacy-Policy', animation: 's2' },
      },
      {
        path: 'search',
        component: SearchPageComponent,
        data: { title: 'Search', animation: 's2' },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}
